// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as UserADefault } from '../../../assets/icons/default/users/user-a.svg?react';
import { ReactComponent as UserASolid } from '../../../assets/icons/solid/users/USER-A.svg?react';
import { createIcons } from '../../Icon';
const UserAIcon = /* @__PURE__ */ createIcons('UserA', {
    default: UserADefault,
    solid: UserASolid
});
UserAIcon.supportedTypes = ['default', 'solid'];
UserAIcon.category = 'users';
export default UserAIcon;
